var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 3.5C27.3812 3.5 27.2594 3.52188 27.1375 3.57188L9.125 10.8094H4C3.725 10.8094 3.5 11.0406 3.5 11.3281V20.6719C3.5 20.9594 3.725 21.1906 4 21.1906H7.17812C7.0625 21.5531 7 21.9375 7 22.3281C7 24.3875 8.68125 26.0625 10.75 26.0625C12.4812 26.0625 13.9406 24.8875 14.3719 23.3L27.1406 28.4312C27.2625 28.4781 27.3844 28.5031 27.5031 28.5031C28.0312 28.5031 28.5031 28.0594 28.5031 27.4656V4.5375C28.5 3.94375 28.0312 3.5 27.5 3.5ZM10.75 23.8219C9.92187 23.8219 9.25 23.1531 9.25 22.3281C9.25 21.9781 9.37187 21.6437 9.59375 21.3781L12.2469 22.4437C12.1844 23.2125 11.5375 23.8219 10.75 23.8219ZM26.25 25.6469L9.9625 19.1031L9.55937 18.9406H5.75V13.0594H9.55937L9.9625 12.8969L26.25 6.35312V25.6469Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b4fa67196374cae559f50e855b2903fc.svg";
export { ForwardRef as ReactComponent };